(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  exports.ChemicalsValidator = (function() {
    function ChemicalsValidator(hot, chemicals) {
      this.markValid = bind(this.markValid, this);
      this.markInvalid = bind(this.markInvalid, this);
      this.validateCategory = bind(this.validateCategory, this);
      this.validateModeOfAction = bind(this.validateModeOfAction, this);
      this.validateWindSpeed = bind(this.validateWindSpeed, this);
      this.validateName = bind(this.validateName, this);
      this.hot = hot;
      this.chemicals = chemicals;
      this.is_valid = true;
      this.validation_messages = [];
    }

    ChemicalsValidator.prototype.validateName = function(cell, callback) {
      var chemical, i, len, other_chemical, ref;
      if (cell.ignore) {
        return this.markValid(callback);
      }
      if ((cell.value == null) || cell.value.trim() === '') {
        return this.markInvalid(callback, 'Chemical Name must be set.');
      }
      chemical = this.hot.getSourceDataAtRow(cell.row);
      ref = this.chemicals;
      for (i = 0, len = ref.length; i < len; i++) {
        other_chemical = ref[i];
        if (other_chemical === chemical) {
          continue;
        }
        if (other_chemical.name === cell.value) {
          return this.markInvalid(callback, 'Chemical Name must be unique.');
        }
      }
      return this.markValid(callback);
    };

    ChemicalsValidator.prototype.validateWindSpeed = function(cell, callback) {
      if (cell.ignore || (cell.value == null) || cell.value === '') {
        return this.markValid(callback);
      }
      if (!($.isNumeric(cell.value) && (Math.floor(cell.value) === cell.value))) {
        return this.markInvalid(callback, 'Max Wind Speed must be numeric.');
      }
      if (parseInt(cell.value, 10) < 0 || parseInt(cell.value, 10) > 99) {
        return this.markInvalid(callback, 'Max Wind Speed must be between 0 and 99 mph.');
      }
      return this.markValid(callback);
    };

    ChemicalsValidator.prototype.validateModeOfAction = function(cell, callback) {
      var chemical, ref, ref1;
      if (cell.ignore || (cell.value == null) || cell.value === '') {
        return this.markValid(callback);
      }
      chemical = this.hot.getSourceDataAtRow(cell.row);
      if (!((ref = chemical.children) != null ? ref.length : void 0) && ((ref1 = String(cell.value)) !== '1' && ref1 !== '1A' && ref1 !== '1B' && ref1 !== '2' && ref1 !== '2B' && ref1 !== '3' && ref1 !== '4' && ref1 !== '4A' && ref1 !== '4D' && ref1 !== '5' && ref1 !== '6' && ref1 !== '7' && ref1 !== '7A' && ref1 !== '8' && ref1 !== '8B' && ref1 !== '8F' && ref1 !== '9' && ref1 !== '10' && ref1 !== '10A' && ref1 !== '10B' && ref1 !== '11' && ref1 !== '11A' && ref1 !== '12' && ref1 !== '12C' && ref1 !== '13' && ref1 !== '14' && ref1 !== '15' && ref1 !== '16' && ref1 !== '17' && ref1 !== '18' && ref1 !== '19' && ref1 !== '20' && ref1 !== '20A' && ref1 !== '21' && ref1 !== '22' && ref1 !== '23' && ref1 !== '24' && ref1 !== '24A' && ref1 !== '25' && ref1 !== '26' && ref1 !== '27' && ref1 !== '28' && ref1 !== '29' && ref1 !== '33' && ref1 !== '44' && ref1 !== 'M1' && ref1 !== 'M2' && ref1 !== 'M3' && ref1 !== 'M4' && ref1 !== 'M5' && ref1 !== 'P5' && ref1 !== 'UN')) {
        return this.markInvalid(callback, 'Mode of Action must be valid.');
      }
      return this.markValid(callback);
    };

    ChemicalsValidator.prototype.validateCategory = function(cell, callback) {
      var ref;
      if (cell.ignore || !cell.value) {
        return this.markValid(callback);
      }
      if (ref = cell.value, indexOf.call(['Fungicide', 'Herbicide', 'Insecticide', 'Growth Regulator', 'Fumigant', 'Defoliant'], ref) < 0) {
        return this.markInvalid(callback, 'Category must be one of Fungicide, Herbicide, Insecticide, Growth Regulator, Fumigant, or Defoliant.');
      }
      return this.markValid(callback);
    };

    ChemicalsValidator.prototype.markInvalid = function(callback, message) {
      if (indexOf.call(this.validation_messages, message) < 0) {
        this.validation_messages.push(message);
      }
      this.is_valid = false;
      callback(false);
      return false;
    };

    ChemicalsValidator.prototype.markValid = function(callback) {
      callback(true);
      return true;
    };

    return ChemicalsValidator;

  })();

}).call(this);
